





































import { Component, mixins } from '@niknevis/vue-modules'
import FilterRow from '@/modules/common/filter/components/shared/layout/FilterRow.vue'
import PaginationWithInput from '@/modules/shared/components/shared/pagination/PaginationWithInput.vue'
import { QsSearchableMixin } from '@/modules/shared/mixins/qs-searchable.mixin'
import { QsPaginatableMixin } from '@/modules/shared/mixins/qs-paginatable.mixin'
import { Prop, ProvideReactive } from 'vue-property-decorator'
import { CouponCollectionType } from '@/modules/coupon/models/coupon-collection.model'
import TesTable from '@/modules/common/tes-table/components/shared/TesTable.vue'
import AdminLayout from '@/modules/common/layout/components/admin/AdminLayout.vue'
import { adminCouponIndexPageTableColumn } from '@/modules/coupon/models/columns/admin-coupon-index-page-table.column'
import AdminCouponIndexPageTableRow from '@/modules/coupon/components/admin/table/AdminCouponIndexPageTableRow.vue'
import { Filter, FilterTypes } from '@/modules/common/filter/filter'
import AdminUserSearchFilter from '@/modules/user/components/admin/AdminUserSearchFilter.vue'
import collect from 'collect.js'
import BaseButton from '@/modules/shared/components/shared/kit/BaseButton.vue'
import AdminCreateCouponDialog from '@/modules/coupon/components/admin/AdminCreateCouponDialog.vue'

@Component({
  layout: AdminLayout,
  layoutProps: {
    page_header: 'کوپن‌های تخفیف'
  },
  metaInfo: {
    title: 'کوپن‌های تخفیف'
  },
  components: {
    BaseButton,
    TesTable,
    FilterRow,
    PaginationWithInput
  }
})
export default class AdminCouponIndexPage extends mixins(QsSearchableMixin, QsPaginatableMixin) {
  @Prop() coupons: CouponCollectionType
  private rowComponent = AdminCouponIndexPageTableRow
  private columns = adminCouponIndexPageTableColumn()

  private filters = [
    new Filter({
      type: FilterTypes.Select,
      title: 'وضعیت',
      key: 'status',
      holder: 'انتخاب کنید',
      default: this.coupons.default_filters.status,
      typeMode: false,
      items: collect(this.coupons.statuses)
        .map((item, index) => ({
          label: item,
          value: index
        })).toArray()
    }),
    new Filter({
      type: FilterTypes.Select,
      title: 'نوع',
      key: 'type',
      holder: 'انتخاب کنید',
      typeMode: false,
      items: collect(this.coupons.types)
        .map((item, index) => ({
          label: item,
          value: index
        })).toArray()
    }),
    new Filter({
      type: FilterTypes.Custom,
      key: 'users',
      title: 'کاربر',
      typeMode: false,
      component: AdminUserSearchFilter,
      props: {
        multiple: true
      }
    }),
    new Filter({
      type: FilterTypes.Toggle,
      title: 'نمایش پیشنهاد ویژه',
      key: 'special_offer',
      holder: 'انتخاب کنید',
      typeMode: false
    })
  ]

  protected get model() {
    return this.coupons
  }

  @ProvideReactive()
  get couponFixedData() {
    return {
      statuses: this.coupons.statuses,
      types: this.coupons.types
    }
  }

  private updatePage(page: number) {
    this.updateTable({
      pagination: {
        ...this.pagination,
        page
      }
    })
  }

  private openCreateCouponDialog() {
    this.$q.dialog({
      component: AdminCreateCouponDialog,
      campaignTypesInPersian: this.coupons.types,
      couponStatuses: this.coupons.statuses,
      couponDiscountUnits: this.coupons.discount_units
    })
  }
}
